import React from 'react';
import { useSelector } from 'react-redux';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import PropTypes from 'prop-types';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import { Button, Chip } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { STATUS_COLORS } from 'consts/mapConfig';
import Icons from 'consts/icons';
import { FiltersDetailsUseStyles } from './FiltersUseStyles';

const Filters = props => {
  const {
    filters,
    setFiltersData,
    setFiltersDataMissions,
    dropdownOptionsToSpecifyKeyValuesToFilter,
  } = props;
  const subtitles = useSelector(state => state.language).filtersComponentv2;

  const [pickedFilters, setPickedFilters] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [heightError, setHeightError] = React.useState(false);
  const [tagsValue, setTagsValue] = React.useState({});

  const classes = FiltersDetailsUseStyles();

  const handleChange = event => {
    setPickedFilters([...pickedFilters, event.target.value]);
  };

  const handleDeleteFilter = filterName => {
    setTagsValue(
      Object.fromEntries(
        Object.entries(tagsValue).filter(([key, value]) => key !== filterName)
      )
    );
    if (filterName === 'status_operations') setFiltersData({ status: null });
    if (filterName === 'status_missions')
      setFiltersDataMissions({ status: null });
    setPickedFilters(pickedFilters.filter(x => x !== filterName));
  };

  const returnFilterRequest = event => {
    const filterObject = {};
    if (tagsValue !== {}) {
      Object.keys(tagsValue).map(
        key =>
          (filterObject[key] =
            tagsValue[key].length === 1 ? tagsValue[key][0] : tagsValue[key])
      );
    }
    if (event?.target) {
      for (let i = 1; i < event.target.length; i += 1) {
        if (event.target[i].name) {
          filterObject[event.target[i].name] = event.target[i].value;
        }
      }
    }
    handleValidateHeight(filterObject);
    return filterObject;
  };

  const handleSubmitForm = event => {
    event.preventDefault();
    const requestFilterObject = returnFilterRequest(event);
    const dataValues = Object.fromEntries(
      Object.entries(requestFilterObject).filter(
        ([key, value]) => key !== 'status_missions'
      )
    );
    if (requestFilterObject.status_operations) {
      dataValues.status = dataValues?.status_operations;
      delete dataValues.status_operations;
    }
    setFiltersData(dataValues);

    if (setFiltersDataMissions) {
      const missions = Object.fromEntries(
        Object.entries(requestFilterObject).filter(
          ([key, value]) => key !== 'status_operations'
        )
      );

      if (missions.status_missions) {
        missions.status = missions.status_missions;
        delete missions.status_missions;
      }

      setFiltersDataMissions(missions);
    }
  };

  const handleValidateHeight = filterObject => {
    if (!filterObject.minHeight || !filterObject.maxHeight) return;
    if (parseInt(filterObject.minHeight) >= parseInt(filterObject.maxHeight))
      setHeightError(true);
  };

  const showError = type =>
    (type === 'minHeight' || type === 'maxHeight') && heightError;

  return (
    <Grid container className={`${classes.FiltersDetails}__table`}>
      <Grid
        item
        xs={10}
        className={`${classes.FiltersDetails}__table__filters__add`}
      >
        {filters.length !== pickedFilters.length ? (
          <FormControl
            focused={open}
            className={`${classes.FiltersDetails}__table__filters__add__form`}
          >
            <InputLabel
              id="label-1"
              classes={{
                root: `${classes.FiltersDetails}__table__filters__add__form__label`,
                focused: `${classes.FiltersDetails}__table__filters__add__form__label--focused`,
              }}
            >
              {subtitles.header_}
            </InputLabel>
            <Select
              className={`${classes.FiltersDetails}__table__filters__add__form__select ${classes.FiltersDetails}__table__filters__add__form__underline`}
              labelId="label-1"
              id="select-1"
              MenuProps={{
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
                getContentAnchorEl: null,
              }}
              onChange={handleChange}
              onClose={() => setOpen(false)}
              value=""
              onOpen={() => setOpen(true)}
            >
              {filters
                .filter(f => !pickedFilters.includes(f))
                .map((eachFilter, index) => (
                  <MenuItem key={`toPick${index}`} value={eachFilter}>
                    {subtitles[`${eachFilter}_`]}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        ) : null}
      </Grid>
      <Grid
        item
        xs={2}
        className={`${classes.FiltersDetails}__table__filters__search`}
      >
        <Button
          type="submit"
          form="filterform"
          className={`${classes.FiltersDetails}__table__filters__search__button`}
        >
          <Icons.Actions.Search />
        </Button>
      </Grid>
      <form
        id="filterform"
        onSubmit={handleSubmitForm}
        className={classes.Filters}
      >
        <Grid container spacing={1}>
          {pickedFilters.map((type, index) =>
            type !== 'height' &&
            type !== 'status_operations' &&
            type !== 'status_missions' &&
            type !== 'type' ? (
              <Grid
                item
                xs={6}
                className={`${classes.Filters}__filter-wrapper`}
              >
                <Icons.Actions.Clear
                  className={`${classes.FiltersDetails}__table__filters__add__details__button__close`}
                  onClick={() => {
                    handleDeleteFilter(type);
                  }}
                />
                <TextField
                  key={`picked${index}`}
                  id={type}
                  name={type}
                  error={showError(type)}
                  label={subtitles[`${type}_`]}
                  InputProps={{
                    classes: {
                      root: `${classes.FiltersDetails}__table__filters__add__form__underline`,
                      input: `${classes.FiltersDetails}__table__filters__add__form--color`,
                    },
                  }}
                  InputLabelProps={{
                    classes: {
                      root: `${classes.FiltersDetails}__table__filters__add__form__label`,
                      focused: `${classes.FiltersDetails}__table__filters__add__form__label--focused`,
                    },
                  }}
                />
              </Grid>
            ) : null
          )}
          {pickedFilters
            .filter(
              type =>
                type === 'status_operations' ||
                type === 'status_missions' ||
                type === 'type'
            )
            .map((type, index) => (
              <Grid
                item
                key={index}
                xs={6}
                className={`${classes.Filters}__filter-wrapper`}
              >
                <Icons.Actions.Clear
                  className={`${classes.FiltersDetails}__table__filters__add__details__button__close`}
                  onClick={() => {
                    handleDeleteFilter(type);
                  }}
                />
                <Autocomplete
                  multiple
                  id="tags-standard"
                  limitTags={2}
                  size="small"
                  options={
                    Object.values(
                      dropdownOptionsToSpecifyKeyValuesToFilter[type]
                    ) || []
                  }
                  getOptionLabel={option => option || ''}
                  filterSelectedOptions
                  defaultValue={[]}
                  onChange={
                    (e, v) => setTagsValue({ ...tagsValue, [type]: v })
                    // eslint-disable-next-line react/jsx-curly-newline
                  }
                  value={tagsValue?.items}
                  autoComplete
                  classes={{
                    root: `${classes.Filters}__autocomplete`,
                    endAdornment: `${classes.Filters}__autocomplete__button`,
                    inputRoot: `${classes.FiltersDetails}__table__filters__add__form__underline`,
                    tag: `${classes.FiltersDetails}__table__filters__add__form--color`,
                  }}
                  renderTags={
                    (value, getTagProps) =>
                      value.map((option, i) => (
                        <Chip
                          variant="outlined"
                          size="small"
                          key={i}
                          label={option}
                          style={{
                            border: `2px solid ${STATUS_COLORS[option]?.stroke}`,
                            backgroundColor: STATUS_COLORS[option]?.stroke,
                            color: 'white',
                          }}
                          // eslint-disable-next-line react/jsx-props-no-spreading
                          {...getTagProps({ i })}
                        />
                      ))
                    // eslint-disable-next-line react/jsx-curly-newline
                  }
                  renderInput={(params, idx) => (
                    <TextField
                      // eslint-disable-next-line react/jsx-props-no-spreading
                      {...params}
                      key={idx}
                      InputLabelProps={{
                        classes: {
                          root: `${classes.FiltersDetails}__table__filters__add__form__label`,
                          focused: `${classes.FiltersDetails}__table__filters__add__form__label--focused`,
                        },
                      }}
                      variant="standard"
                      placeholder={subtitles[`${type}_`]}
                      label={subtitles[`${type}_`]}
                    />
                  )}
                />
              </Grid>
            ))}
        </Grid>
      </form>
    </Grid>
  );
};

Filters.propTypes = {
  filters: PropTypes.array.isRequired,
  setFiltersData: PropTypes.func,
  setFiltersDataMissions: PropTypes.func,
  dropdownOptionsToSpecifyKeyValuesToFilter: PropTypes.object,
};

export default Filters;
